import axios from "axios"

export default {
    state: {
        teams: []
    },
    getters: {
        teams(state) {
            return state.teams;
        }
    },
    mutations: {
        setTeams(state, teams) {
            state.teams = teams;
        }
    },
    actions: {
        async getTeacher({ commit }) {
            let res = await axios.get('/person/2');
            let teams = res.data.data;

            commit('setTeams', teams)
        }
    }
}